"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSlide = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _CarouselSlide = require("./CarouselSlide.styles");
var _excluded = ["slideAlign", "slideWidth"];
/**
 * Wrapper for a piece of content displayed in a `Carousel`.
 *
 * @extends Flex
 * @since 8.71.0
 */
var CarouselSlide = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var slideAlign = _ref.slideAlign,
    slideWidth = _ref.slideWidth,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_CarouselSlide.StyledCarouselSlide, (0, _extends2.default)({
    as: "li",
    slideAlign: slideAlign,
    slideWidth: slideWidth,
    ref: forwardedRef
  }, rest));
});
exports.CarouselSlide = CarouselSlide;
CarouselSlide.displayName = 'CarouselSlide';
CarouselSlide.propTypes = {
  /**
   * Determines how a slide should try to align within its container. Applied using
   * [`scroll-snap-align`](https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-snap-align).
   */
  slideAlign: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center'])),
  /**
   * Sets the width of a slide using `flex-basis`. Takes a number or the,
   * default, `auto`.
   *
   * Supports inline media query objects.
   */
  slideWidth: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]))
};
CarouselSlide.defaultProps = {
  slideAlign: 'start',
  slideWidth: 'auto'
};